import React from 'react'
import Phonecall from "../../Images/phoencalimage.png"
import Address from "../../Images/adressimage.png"
import Emailimage from "../../Images/emailimage.png"
import HomeNavbar from './HomeNavbar'
import Footer from './Footer'
import { Icon } from 'lucide-react'
import { FaAngleRight } from 'react-icons/fa'
import { useNavigate } from "react-router-dom";
import Link from "react-router-dom"


function TermsCondition() {
  const navigate = useNavigate();
  return (
   <>
   <HomeNavbar />
      <div
          id="faqs-page"
          className="bg-white w-full py-20  text-center font-oswald mt-10"
        >
          <div className=" flex items-center justify-center">
            <p
              style={{ backgroundColor: "#F5A623" }}
              className="  rounded-full py-2 px-6 font-bold text-bgBlue"
            >
             T&C
            </p>
          </div>
          <br />
          <h2 className="text-3xl font-bold text-gray-900  animate-fade-in">
            Term's &<span className="text-secondary"> Condition's </span>{" "}
          </h2>
         
         

         <div className='lg:w-3/4 m-auto shadow-xl'>
         <div className=" text-bgBlue p-8">
      <div className="text-start">
        <h1 className="text-4xl font-bold mb-4">Terms and Conditions</h1>
        <p className="mb-4">Effective Date:30 Nov 2025</p>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Introduction</h2>
          <p className="mb-2">
            This website and mobile application <strong>Adhyayi</strong>(“Platform”) is owned
and operated by <strong>AKRYPT IT SOLUTIONS PRIVATE LIMITED</strong>, a company incorporated under
the Companies Act, 2013, having its registered office in India.
          </p>
          <p className="mb-2">These Terms and Conditions (“Terms”) govern your access to and use of the Platform, including
its services, content, courses, quizzes, contests, rewards, and related features.</p>
            <p className="mb-2">By accessing or using the Platform, you agree to be legally bound by these Terms. If you do not
agree, please do not use the Platform.</p>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Acceptance of Terms</h2>
          <p className="mb-2">
           By registering, accessing, or using Adhyayi, you confirm that you have read, understood, and agreed to these Terms & Conditions and all related policies, including the Privacy Policy, Refund & Cancellation Policy, Fair Play & Anti-Fraud Policy, Contest Rules, Reward Rules, and other applicable platform guidelines.
          </p>
          <p className="mb-2">Continued use of the Platform after any updates constitutes acceptance of the revised Terms and policies.</p>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Nature of Platform – Skill-Based Educational Platform</h2>
          <p className="mb-2">
            Adhyayi is a <strong>skill-based educational platform</strong>.
          </p>
          <ul className="list-disc ml-6">
                <li> All quizzes, contests, and activities are based on user knowledge, preparation, and
performance</li>
                <li> The Platform <strong>does NOT involve gambling, betting, wagering, or games of chance</strong></li>
                <li> Outcomes are determined by <strong>skill, accuracy, and time taken,</strong> not luck</li>
                <li> The Platform promotes learning, assessment, and educational engagement</li>
            </ul>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Use of Services</h2>
          <p className="mb-2">
            The Platform provides:
          </p>
          <ul className="list-disc ml-6">
                <li> Educational courses</li>
                <li> MCQs, quizzes, and assessments</li>
                <li> Skill-based contests</li>
                <li> Performance-based rewards</li>
            </ul>
            <p>All content is for <strong>personal educational use only</strong></p>
            <p>Unauthorized resale, reproduction, or distribution is prohibited.</p>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Account Registration</h2>
          <p className="mb-2">
            Users must:
          </p>
          <ul className="list-disc ml-6">
            <li> Provide accurate information</li>
            <li> Maintain only one account</li>
            <li> Keep login credentials secure</li>
            </ul>
            <p>Duplicate or fake accounts may be suspended or terminated.</p>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>User Responsibilities</h2>
          <p className="mb-2">
            Users agree to:
          </p>
          <ul className="list-disc ml-6">
            <li> Use the Platform fairly and honestly</li>
            <li> Not engage in cheating, bots, or manipulation</li>
            <li> Not misuse system loopholes</li>
            </ul>

            <p className="mb-2">
            Violation may result in:
          </p>
          <ul className="list-disc ml-6">
            <li> Account suspension</li>
            <li> Reward forfeiture</li>
            <li> Permanent termination</li>
            </ul>
            
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Courses & Educational Content</h2>
          <ul className="list-disc ml-6">
            <li> Content includes MCQs, videos, PDFs, etc.</li>
            <li> Designed for exam preparation</li>
            <li> No guarantee of exam success</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Contests & Challenges</h2>
          <ul className="list-disc ml-6">
            <li> Contests are skill-based</li>
            <li> Rankings depend on performance, accuracy, and time</li>
          </ul>

          <h2 className="text-lg font-semibold ml-2">◦ State Restrictions</h2>
          <p className="ml-6">
            Participation may be restricted in certain regions due to local laws.
          </p>
          <p className="ml-6 mb-2">
            Users are responsible for ensuring legal compliance in their location.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Credits & Virtual Rewards</h2>
          <ul className="list-disc ml-6">
            <li> Credits are virtual reward points, not real currency</li>
            <li> Credits do not represent legal tender or stored value</li>
          </ul>
          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Credit Value</h3>
          <ul className="list-disc ml-6">
            <li> The indicative value (e.g., 100 Credits = ₹1) may change at Platform discretion</li>
            <li> The Platform may modify, restrict, or forfeit Credits at any time</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Wallet Structure & Withdrawal Rules</h2>
          
          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Wallet Categories</h3>
          <ul className="list-disc ml-6">
            <li> Contest Credits</li>
            <li> Referral Credits</li>
            <li> Quiz/Course Credits</li>
            <li> Recharge Credits</li>
          </ul>

          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Withdrawable Balance</h3>
          <p className="">
            Only Contest, Referral, and Quiz/Course Credits are withdrawable.
          </p>
          <p className="mb-2">
            Recharge Credits are <strong>non-withdrawable</strong>.
          </p>

          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Minimum Withdrawal Requirement</h3>
          <p className="mb-2">
            Withdrawals are subject to a minimum withdrawal threshold as defined by the Platform from time to time.
          </p>

          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Free Withdrawal Policy</h3>
          <p className="mb-2">
           New users may withdraw rewards earned from Free Contests up to the lifetime limit defined by Adhyayi (currently ₹200). After reaching this limit, further withdrawals will require the purchase of an eligible Adhyayi Plan. The lifetime withdrawal limit may be updated by Adhyayi at its sole discretion.
          </p>

          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Withdrawal Priority</h3>
          <p className="mb-2">
            Credits are deducted in the following order:
          </p>
          <ol style={{listStyleType: "decimal"}} className="ml-6">
            <li> Contest Credits</li>
            <li> Referral Credits</li>
            <li> Quiz/Course Credits</li>
          </ol>

          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Recharge Credits</h3>
          <p className="mb-2">
            Recharge Credits:
          </p>
          <ul className="list-disc ml-6">
            <li> Are purchased using real money</li>
            <li> Can only be used within the Platform</li>
            <li> <strong>Cannot be withdrawn or converted into cash</strong></li>
          </ul>

          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Quiz Credits Lock</h3>
          <p className="">
            Quiz/Course Credits may be <strong>locked for a defined period (e.g., 30 days)</strong> and cannot be withdrawn during this time.
          </p>
          <p className="mb-2">
            However, they may be used for contest participation.
          </p>

          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Plan Recovery Policy (Very Important)</h3>
          <p className="mb-2">
            Certain plans may be offered at a discounted promotional price. By purchasing such plans, the user agrees that the discounted amount may be recovered from future contest rewards before withdrawals become available. During the recovery period, contest participation will continue normally; however, withdrawals will remain restricted until the pending recovery amount is fully adjusted.
          </p>

          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Reward Adjustment</h3>
          <p className="mb-2">
            Adhyayi reserves the right to automatically adjust earned rewards against any applicable pending recovery amount before making rewards available for withdrawal.
          </p>

          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Wallet & Rewards</h3>
          <p className="mb-2">
            Rewards earned on Adhyayi are promotional platform rewards and are governed by Adhyayi’s Contest and Reward Policy. Wallet balances do not represent a bank deposit or guaranteed cash until they become eligible for withdrawal under the applicable platform rules.
          </p>

        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Rewards, Payouts & Withdrawals</h2>
          <ul className="list-disc ml-6">
            <li> Rewards are <strong>performance-based incentives</strong>, not guaranteed earnings</li>
          </ul>

          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Withdrawal Requirements</h3>
          <p className="mb-2">
            Withdrawals are subject to:
          </p>
          <ul className="list-disc ml-6">
            <li> Minimum threshold</li>
            <li> KYC verification</li>
            <li> Compliance checks</li>
          </ul>

          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Platform Rights</h3>
          <p className="mb-2">
            The Platform may:
          </p>
          <ul className="list-disc ml-6">
            <li> Delay, withhold, or reverse withdrawals</li>
            <li> Reject withdrawals in case of fraud or violations</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Scoring, Ranking & Eligibility</h2>
          
          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Quiz Scoring & Rewards</h3>
          <p className="mb-2">
            The Platform may apply scoring systems that include positive marks for correct answers and deductions for incorrect or skipped answers.
          </p>
          <ul className="list-disc ml-6">
            <li> Correct Answer: May earn Credits</li>
            <li> Incorrect Answer: May result in deduction</li>
            <li> Skipped Questions: May have neutral or minimal impact</li>
          </ul>
          <p className="mb-2 mt-4">
            Actual scoring rules may vary across quizzes, courses, or activities and are subject to change at the Platform's discretion.
          </p>

          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Contest Scoring & Rewards</h3>
          <p className="mb-2">
            The Platform applies performance-based scoring systems in contests.
          </p>
          <ul className="list-disc ml-6">
            <li> Scores are calculated based on correct and incorrect answers</li>
            <li> Incorrect answers may result in negative marking (e.g., multiple incorrect answers may reduce the overall score)</li>
          </ul>

          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Ranking Criteria</h3>
          <p className="mb-2">
            Ranking is determined based on:
          </p>
          <ul className="list-disc ml-6">
            <li> Higher score</li>
            <li> Better accuracy</li>
            <li> Less time taken</li>
            <li> Earlier submission (in case of tie)</li>
          </ul>

          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Reward Eligibility</h3>
          <p className="mb-2">
            Users with zero or negative scores may not be eligible for rewards.
          </p>
          <p className="mb-2">
            The Platform reserves the right to determine scoring methods, ranking criteria, and reward eligibility at its sole discretion.
          </p>

          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Free Contest Eligibility</h3>
          <p className="mb-2">
Free Contests are intended for new and eligible users only. Adhyayi reserves the right to determine a user’s eligibility for Free Contests. Users who have won eligible Free Contests may lose access to future Free Contests and may be required to participate in Paid Contests or other eligible contests, as determined by the platform.
          </p>
          
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>KYC & Verification</h2>
          <p className="mb-2">
            Users may be required to complete KYC for withdrawals.
          </p>
          <ul className="list-disc ml-6">
            <li> Identity and bank details are collected for verification only</li>
            <li> Data is handled as per Privacy Policy</li>
          </ul>

          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Verified Winner Program</h3>
          <p className="mb-2">
            Users who cross a specified winnings threshold or participate in selected high-value contests may be required to complete additional verification before receiving rewards. Verification may include KYC, identity verification, selfie/liveness verification, or other reasonable measures to ensure fair participation.
          </p>

          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Reward Verification</h3>
          <p className="mb-2">
            Adhyayi reserves the right to temporarily withhold rewards while conducting verification if suspicious, unusual, or potentially fraudulent activity is detected. Rewards will be released after successful verification.Adhyayi reserves the right to temporarily withhold rewards while conducting verification if suspicious, unusual, or potentially fraudulent activity is detected. Rewards will be released after successful verification.
          </p>

          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Additional Verification</h3>
          <p className="mb-2">
           Adhyayi may request additional verification, including identity documents or live verification, for selected users based on risk assessment, reward amount, contest category, or security review.

Failure to complete the requested verification within the specified time may result in reward forfeiture or temporary account restrictions.
</p>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Fair Play & Anti-Cheating Policy</h2>
          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Strictly Prohibited</h3>
          <ul className="list-disc ml-6">
            <li> Multiple accounts</li>
            <li> Bots or automation</li>
            <li> Answer sharing or collusion</li>
            <li> Device/IP manipulation</li>
          </ul>

          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Violation Consequences</h3>
          <p className="mb-2">
            Violation may result in:
          </p>
          <ul className="list-disc ml-6">
            <li> Disqualification</li>
            <li> Reward forfeiture</li>
            <li> Account termination</li>
          </ul>

<p>Adhyayi is committed to maintaining a fair, transparent and
  skill-based learning environment for all users.</p>
<p
  onClick={() => navigate(`/fairPlayPolicy`)}
  className="font-semibold text-secondary underline cursor-pointer"
>
 Read Full Fair Play & Anti-Fraud Policy
 
</p>       


 </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>No Income or No Earning Guarantee</h2>
          <ul className="list-disc ml-6">
            <li> The Platform does not guarantee income</li>
            <li> No employer-employee relationship exists</li>
            <li> Rewards are incidental to educational engagement</li>
          </ul>
          <p>
  Read our complete - 
 
  <span  onClick={() => navigate(`/riskDiscloserPolicy`)}
  class="font-semibold text-secondary underline cursor-pointer">
     Risk Disclosure & No Earnings Guarantee Policy
  </span>
 
</p>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Intellectual Property</h2>
          <p className="mb-2">
           All content, trademarks, and materials belong to Adhyayi and are protected under law.
Unauthorized use is prohibited.
          </p>
        </section>


        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Limitation of Liability</h2>
          <p className="mb-2">
            The Platform is provided “as is”
          </p>
          <p className="mb-2">Adhyayi is not liable for:
          </p>
          <ul className="list-disc ml-6">
            <li>Loss of rewards</li>
            <li>Data loss</li>
            <li>User performance outcomes</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Suspension & Termination</h2>
          <p className="mb-2">
            Accounts may be suspended or terminated:
          </p>
          <ul className="list-disc ml-6">
            <li> Without notice</li>
            <li> For policy violations</li>
            <li> For harmful conduct</li>
          </ul>
          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Account Suspension</h3>
<p className="mb-2">
  Adhyayi reserves the right to suspend, restrict, or terminate accounts where there is credible evidence of violation of the Fair Play Policy. For security reasons, Adhyayi is not obligated to disclose its fraud detection methods or internal security mechanisms.
  </p>
  <p className="mb-2">
 In cases of permanent account termination due to Fair Play or fraud-related violations, the decision of Adhyayi shall be final and binding. No appeal, review, or reconsideration request will be accepted after such termination.
 </p>
          <h3 className="text-xl font-semibold mb-2 mt-4">◦ Re-Registration After Termination</h3>
<p className="mb-2">
  
Users whose accounts have been permanently suspended or terminated are prohibited from creating or using another account on Adhyayi.

If such a user is found using a new account, Adhyayi reserves the right to immediately terminate the account, cancel all rewards, recover any fraudulently obtained benefits (where permitted by law).
</p>

        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Risk Disclosure</h2>
          <p className="mb-2">
            Participation is performance-based.
          </p>
          <p className="mb-2">
            Users may not earn rewards in every activity.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Governing Law</h2>
          <p className="mb-2">
            These Terms are governed by Indian law.
          </p>
          <p className="mb-2">
            Jurisdiction: Burhanpur, Madhya Pradesh
          </p>
        </section>

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Changes to Terms</h2>
          <p className="mb-2">
            Adhyayi may update these Terms and Conditions at any time. Continued use of the Platform after such updates constitutes your acceptance of the revised Terms.
          </p>
          <p className="mb-2">
            Continued use implies acceptance.
          </p>
        </section>

       

        <section className="mb-8">
          <h2 className="flex items-center text-2xl font-semibold mb-2"><span className="text-secondary text-5xl mr-2">•</span>Contact Information</h2>
          <p className="mb-2">
            If you have any questions about these Terms and Conditions, please
            contact us at{" "}
            <a
              href="mailto:support@adhyayi.com"
              className="text-blue-500 underline"
            >
              support@adhyayi.com
            </a>
            .
          </p>
        </section>
      </div>
    </div>
         </div>
        </div>
        <Footer/>
   </>
  )
}

export default TermsCondition
